export default {
    props: {
        count: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            currentSlide: 1,
            timeout: null
        }
    },

    mounted() {
        this.timeout = window.setTimeout(this.nextSlide, 5000);
    },

    methods: {
        isActive(index) {
            return this.currentSlide === index;
        },

        select(index) {
            this.currentSlide = index;
            window.clearTimeout(this.timeout);
            return this.timeout = window.setTimeout(this.nextSlide, 5001);
        },

        nextSlide() {
            if (this.currentSlide === this.count) {
                return this.select(1);
            }

            this.select(this.currentSlide + 1);
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/components/Promotions.js